module.exports = __webpack_public_path__ + "img/loads-2.ba9f3e59.jpeg";